export default function hasPermit($rootScope, operationService) {
  return {
    link(scope, element, attrs) {
      if (typeof attrs.hasPermit !== 'string') {
        console.error('权限控制组件参数为字符串')
      }
      const value = attrs.hasPermit.trim()
      function toggleVisibility() {
        // 由于目前没有配置数据库 按钮对应functioncode 暂时 统一返回   return 显示 !!!!!!!!!!
        // return;
        if (!value) {
          return
        }
        const hasPermission = operationService.hasPermit(value)
        if (hasPermission) {
          element.show()
        } else {
          element.hide()
        }
      }
      toggleVisibility()
      // 订阅权限改变事件
      $rootScope.$on('permissionsChanged', toggleVisibility)
    },
  }
}
hasPermit.$inject = ['$rootScope', 'operationService']



// WEBPACK FOOTER //
// ./src/components/hasPermit/hasPermitDirective.js